import { Button, Popover, Tooltip } from "antd";
import React from "react";
import { QuestionCircleFilled } from '@ant-design/icons';

interface IHelperPopoverProps {
    title?: string;
    descriptionPopoverContent: React.ReactNode;
    placement?: 'top' | 'left' | 'right' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'leftTop' | 'leftBottom' | 'rightTop' | 'rightBottom';
    style?: React.CSSProperties;
}
const HelperPopover = (props: IHelperPopoverProps) => {

    const [descriptionPopoverOpen, setDescriptionPopoverOpen] = React.useState<boolean>(false);

    React.useEffect(() => {
        //handle MouseClick on other places to close popover
        const handleClick = () => {
            if (descriptionPopoverOpen)
                setDescriptionPopoverOpen(false);
        };

        window.addEventListener('click', handleClick);

        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, [descriptionPopoverOpen]);

    const popoverHandleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setDescriptionPopoverOpen(!descriptionPopoverOpen);
    };

    return (
        <Tooltip title={props.title} placement={"right"}>
            <Popover
                trigger={"click"}
                content={props.descriptionPopoverContent}
                placement={props.placement}
                visible={descriptionPopoverOpen}
            >
                <Button
                    icon={<QuestionCircleFilled style={{ transform: "scaleX(-1)" }} />}
                    style={props.style}
                    onClick={popoverHandleClick}
                >
                </Button>
            </Popover>
        </Tooltip>
    );
}
export default HelperPopover;